/**
 * Enum representing key codes for a keypad. These are sent as payload when a key is pressed.
 *
 * @readonly
 * @enum {string}
 * @public
 * @memberof Mojito.Modules.Keypad
 */
export default {
    /** Enter key identifier. */
    ENTER: 'Enter',
    /** Special keypad key dedicated to increment the input value. */
    INCREMENT: 'Increment',
    /** Regular key press (e.g., digit, letter, space) analogically to regular keyboard key. */
    KEY: 'Key',
};
